import {FlagProps} from 'platform/components';
import {match, Pattern} from 'ts-pattern';

import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

/**
 * Maps the core item state (`<STEP>_<STATUS>` from the core exchange item state dictionary) to the flag
 * shown next to the core item title. Empty states have no flag.
 */
export const getCoreItemStateFlag = (coreItemState: string | Nullish): FlagProps | null =>
  match(coreItemState)
    .returnType<FlagProps | null>()
    .with('DELIVERY_NOT_DELIVERED', () => ({
      colorScheme: 'red',
      label: i18n.t('entity.businessCase.financingEnding.operation.result.notDelivered'),
    }))
    .with('AUTHORISATION_DENIED', () => ({
      colorScheme: 'red',
      label: i18n.t('entity.warehouse.labels.coreExchangeItemStateReturnDenied'),
    }))
    .with('RETURN_DONE', () => ({
      colorScheme: 'green',
      label: i18n.t('entity.warehouse.labels.coreExchangeItemStateReturnedToSupplier'),
    }))
    .with('DELIVERY_DONE', () => ({
      colorScheme: 'blue',
      label: i18n.t('entity.auction.state.delivered'),
    }))
    .with('INSPECTION_DONE', () => ({
      colorScheme: 'blue',
      label: i18n.t('entity.warehouse.labels.coreExchangeItemStateInspected'),
    }))
    .with('DEPOSIT_DONE', () => ({
      colorScheme: 'blue',
      label: i18n.t('entity.warehouse.labels.coreExchangeItemStateInWarehouse'),
    }))
    .with('REQUEST_DONE', () => ({
      colorScheme: 'blue',
      label: i18n.t('entity.warehouse.labels.coreExchangeItemStateReturnRequested'),
    }))
    .with('AUTHORISATION_DONE', () => ({
      colorScheme: 'blue',
      label: i18n.t('entity.warehouse.labels.coreExchangeItemStateReturnAuthorised'),
    }))
    .with(Pattern.string.endsWith('_WAITING'), () => ({
      colorScheme: 'blue',
      label: i18n.t('entity.warehouse.labels.coreExchangeStatusWaiting'),
    }))
    .otherwise(() => null);
